import { Ban, CheckCircle2, Clock, Inbox, UserCheck } from 'lucide-react';
import { cn } from '../../lib/cn';

type TicketStatus = 'new' | 'pending' | 'assigned' | 'in_progress' | 'closed' | 'spam';

interface StatusConfig {
  label: string;
  Icon: React.ComponentType<{ className?: string }>;
  classes: string;
}

// 'pending' est un statut virtuel (new + assigned_to != null) calculé côté UI.
// 'assigned', 'closed', 'spam' : conservés uniquement pour l'affichage d'événements historiques.
const statusConfig: Record<TicketStatus, StatusConfig> = {
  new: {
    label: 'Nouveau',
    Icon: Inbox,
    classes: 'bg-red-100 text-red-700',
  },
  pending: {
    label: 'En attente',
    Icon: Clock,
    classes: 'bg-amber-100 text-amber-700',
  },
  in_progress: {
    label: 'Pris en charge',
    Icon: CheckCircle2,
    classes: 'bg-green-100 text-green-700',
  },
  assigned: {
    label: 'Assigné',
    Icon: UserCheck,
    classes: 'bg-neutral-100 text-neutral-500',
  },
  closed: {
    label: 'Archivé',
    Icon: CheckCircle2,
    classes: 'bg-neutral-100 text-neutral-500',
  },
  spam: {
    label: 'Spam',
    Icon: Ban,
    classes: 'bg-neutral-100 text-neutral-500',
  },
};

interface TicketStatusBadgeProps {
  status: string;
  className?: string;
}

export function TicketStatusBadge({ status, className }: TicketStatusBadgeProps) {
  const config = statusConfig[status as TicketStatus] ?? {
    label: status,
    Icon: Inbox,
    classes: 'bg-neutral-100 text-neutral-500',
  };
  const { label, Icon, classes } = config;

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium',
        classes,
        className,
      )}
    >
      <Icon className="w-3 h-3" aria-hidden />
      {label}
    </span>
  );
}
